import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PostContentObjectDetailDataObject } from 'models/service';

type CreatePostRequestBody = {
  post: Post;
};

type Post = {
  attachments?: Array<{ id: string }>;
  community_id?: string;
  group_id?: string;
  html_content: string;
  parent_id?: null | string;
  pinned?: boolean;
  post: {
    html_content: string;
    text_content: string;
  };
  publish_at?: string;
  text_content: string;
  type: 'post';
};

export const createPost = async ({ body }: BodyRequest<CreatePostRequestBody>) =>
  apiClient.post<PostContentObjectDetailDataObject, ApiClientResponse<PostContentObjectDetailDataObject>>(
    routes.posts.create,
    body,
  );
